var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import styled from "styled-components";
export default (function (_a) {
    var error = _a.error;
    console.log("error: ", error);
    return React.createElement(Container, null,
        "\uC624\uB958: ",
        error && error.message);
});
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 10px 0;\n  width: 100%;\n  height: 50px;\n  line-height: 50px;\n  background-color: #ff8787;\n  color: #fff;\n  text-align: center;\n"], ["\n  margin: 10px 0;\n  width: 100%;\n  height: 50px;\n  line-height: 50px;\n  background-color: #ff8787;\n  color: #fff;\n  text-align: center;\n"])));
var templateObject_1;
